import { render, staticRenderFns } from "./StoreTableRegistration.vue?vue&type=template&id=0ed69b26&scoped=true&"
import script from "./StoreTableRegistration.vue?vue&type=script&lang=js&"
export * from "./StoreTableRegistration.vue?vue&type=script&lang=js&"
import style0 from "./StoreTableRegistration.vue?vue&type=style&index=0&id=0ed69b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed69b26",
  null
  
)

export default component.exports